(function () {

  // =========================================================
  // 1. SOLO PRODUCTOS
  // =========================================================

  if (!window.location.pathname.startsWith('/products/')) {
    return;
  }

  const productHandle =
    window.location.pathname
      .match(/^\/products\/([^/?#]+)/)?.[1] || '';

  if (!productHandle) return;


  // =========================================================
  // 2. STORAGE
  // =========================================================

  const storageKey =
    'ivb_kvy_' + productHandle;


  // =========================================================
  // 3. LEER ?kvy=10-30
  //
  // 10 = descuento %
  // 30 = variante objetivo
  //
  // También:
  // ?kvy=10
  // aplicaría a todas las variantes
  // =========================================================

  const params =
    new URLSearchParams(
      window.location.search
    );

  let kvy =
    params.get('kvy') || '';


  if (kvy) {

    sessionStorage.setItem(
      storageKey,
      kvy
    );

  } else {

    kvy =
      sessionStorage.getItem(
        storageKey
      ) || '';

  }


  if (!kvy) {
    return;
  }


  const kvyMatch =
    kvy.match(
      /^(\d{1,2})(?:-(\d+))?$/
    );


  if (!kvyMatch) {
    return;
  }


  const DISCOUNT_PERCENT =
    parseInt(
      kvyMatch[1],
      10
    );


  const variantTarget =
    kvyMatch[2] || '';


  if (
    !Number.isFinite(DISCOUNT_PERCENT) ||
    DISCOUNT_PERCENT <= 0 ||
    DISCOUNT_PERCENT > 50
  ) {
    return;
  }


  // =========================================================
  // 4. CONFIG
  // =========================================================

  const FREE_SHIPPING_THRESHOLD =
    19.90;


  // =========================================================
  // 5. HELPERS
  // =========================================================

  function parsePrice(text) {

    if (!text) {
      return null;
    }

    const match =
      String(text)
        .replace(/\s/g, '')
        .match(
          /(\d+(?:[.,]\d+)?)€/
        );


    if (!match) {
      return null;
    }


    const value =
      parseFloat(
        match[1]
          .replace(',', '.')
      );


    return Number.isFinite(value)
      ? value
      : null;
  }


  function money(value) {

    return Number(value)
      .toFixed(2)
      .replace('.', ',') + '€';
  }


  function discounted(value) {

    return value *
      (
        1 -
        DISCOUNT_PERCENT / 100
      );
  }


  function getVariantNumber(text) {

    const match =
      String(text || '')
        .match(/\d+/);


    return match
      ? match[0]
      : '';
  }


  function getSelectedInput() {

    return document.querySelector(
      '.c-variant__item__input:checked'
    );
  }


  function getLabel(input) {

    if (!input) {
      return null;
    }


    return document.querySelector(
      'label[for="' +
      CSS.escape(input.id) +
      '"]'
    );
  }


  function getVariantText(label) {

    if (!label) {
      return '';
    }


    return (
      label.querySelector(
        '.c-variant__item__label__text'
      )?.textContent || ''
    ).trim();
  }


  function isTarget(label) {

    if (!label) {
      return false;
    }


    // Si no hay variante en ?kvy=XX
    // se aplica a todas.
    if (!variantTarget) {
      return true;
    }


    const current =
      getVariantNumber(
        getVariantText(label)
      );


    return (
      current !== '' &&
      current === variantTarget
    );
  }


  // =========================================================
  // 6. GUARDAR PRECIOS ORIGINALES
  // =========================================================

  const originals =
    new Map();


  function captureOriginals() {

    document
      .querySelectorAll(
        '.c-variant__item__label'
      )
      .forEach(function (label) {

        const key =
          getVariantText(label);


        if (!key) {
          return;
        }


        if (
          originals.has(key)
        ) {
          return;
        }


        const priceEl =
          label.querySelector(
            '.c-variant__item__label__price'
          );


        const ppdEl =
          label.querySelector(
            '.c-variant__item__label__ppd'
          );


        const shippingEl =
          label.querySelector(
            '.c-variant__item__label__shipping'
          );


        if (!priceEl) {
          return;
        }


        // No capturar un precio que
        // ya haya modificado nuestro script.
        if (
          priceEl.querySelector(
            '.kvy-discount-price'
          )
        ) {
          return;
        }


        const price =
          parsePrice(
            priceEl.textContent
          );


        const ppd =
          ppdEl
            ? parsePrice(
                ppdEl.textContent
              )
            : null;


        if (price === null) {
          return;
        }


        originals.set(
          key,
          {
            price: price,
            ppd: ppd,
            shippingText:
              shippingEl
                ? shippingEl.textContent.trim()
                : ''
          }
        );

      });

  }


  // =========================================================
  // 7. PINTAR VARIANTES
  // =========================================================

  function renderVariantCards() {

    captureOriginals();


    document
      .querySelectorAll(
        '.c-variant__item__label'
      )
      .forEach(function (label) {

        const key =
          getVariantText(label);


        const data =
          originals.get(key);


        if (!data) {
          return;
        }


        const priceEl =
          label.querySelector(
            '.c-variant__item__label__price'
          );


        const ppdEl =
          label.querySelector(
            '.c-variant__item__label__ppd'
          );


        const badge =
          label.querySelector(
            '.c-variant__item__label__badge'
          );


        const shippingEl =
          label.querySelector(
            '.c-variant__item__label__shipping'
          );


        if (!priceEl) {
          return;
        }


        // =====================================================
        // PROMO
        // =====================================================

        if (isTarget(label)) {

          const finalPrice =
            discounted(
              data.price
            );


          priceEl.innerHTML = `
            <span
              class="kvy-original-price"
              style="
                text-decoration:line-through;
                opacity:.48;
                margin-right:6px;
                font-weight:400;
              "
            >
              ${money(data.price)}
            </span>

            <span
              class="kvy-discount-price"
              style="
                font-weight:700;
              "
            >
              ${money(finalPrice)}
            </span>
          `;


          if (
            ppdEl &&
            data.ppd !== null
          ) {

            ppdEl.textContent =
              '(' +
              money(
                discounted(
                  data.ppd
                )
              ) +
              ' / día)';
          }


          if (badge) {

            badge
              .querySelectorAll(
                '.kvy-discount-badge'
              )
              .forEach(function (el) {
                el.remove();
              });


            badge.insertAdjacentHTML(
              'beforeend',
              `
                <span
                  class="kvy-discount-badge"
                  style="
                    display:inline-block;
                    margin-left:5px;
                    padding:2px 7px;
                    border-radius:20px;
                    
                    color:white;
                    font-size:10px;
                    line-height:1.2;
                    font-weight:700;
                  "
                >
                  -${DISCOUNT_PERCENT}%
                </span>
              `
            );

          }


          if (shippingEl) {

            shippingEl.textContent =
              finalPrice <
              FREE_SHIPPING_THRESHOLD

                ? '+ Gastos envío'
                : 'Envío gratis!';

          }


        // =====================================================
        // SIN PROMO
        // =====================================================

        } else {

          priceEl.textContent =
            money(
              data.price
            );


          if (
            ppdEl &&
            data.ppd !== null
          ) {

            ppdEl.textContent =
              '(' +
              money(
                data.ppd
              ) +
              ' / día)';
          }


          if (badge) {

            badge
              .querySelectorAll(
                '.kvy-discount-badge'
              )
              .forEach(function (el) {
                el.remove();
              });

          }


          if (shippingEl) {

            shippingEl.textContent =
              data.price <
              FREE_SHIPPING_THRESHOLD

                ? '+ Gastos envío'
                : (
                    data.shippingText ||
                    'Envío gratis!'
                  );

          }

        }

      });

  }


  // =========================================================
  // 8. PRECIO PRINCIPAL
  // =========================================================

  let modifyingMainPrice =
    false;


function renderSingleProduct() {

  // =========================================================
  // SI HAY VARIANTES CON PRECIO PROPIO VISIBLE,
  // ESTE PRODUCTO NO SE TRATA COMO "SINGLE PRODUCT"
  // =========================================================

  const hasPricedVariants =
    document.querySelector(
      '.c-variant__item__label .c-variant__item__label__price'
    );

  if (hasPricedVariants) {
    return false;
  }


  // =========================================================
  // PRECIO PRINCIPAL
  // =========================================================

  const mainPrice =
    document.querySelector(
      '.c-product__header__price .amount'
    );

  const mainPpd =
    document.querySelector(
      '.c-product__ppd'
    );

  if (!mainPrice) {
    return false;
  }


  // =========================================================
  // GUARDAR PRECIO ORIGINAL
  // =========================================================

  if (
    !mainPrice.dataset.kvyOriginalPrice
  ) {

    const original =
      parsePrice(
        mainPrice.textContent
      );

    if (original === null) {
      return false;
    }

    mainPrice.dataset.kvyOriginalPrice =
      String(original);
  }


  // =========================================================
  // GUARDAR €/DÍA ORIGINAL
  // =========================================================

  if (
    mainPpd &&
    !mainPpd.dataset.kvyOriginalPpd
  ) {

    const originalPpd =
      parsePrice(
        mainPpd.textContent
      );

    if (originalPpd !== null) {

      mainPpd.dataset.kvyOriginalPpd =
        String(originalPpd);

    }
  }


  // =========================================================
  // CALCULAR PRECIO FINAL
  // =========================================================

  const originalPrice =
    parseFloat(
      mainPrice.dataset.kvyOriginalPrice
    );

  if (
    !Number.isFinite(originalPrice)
  ) {
    return false;
  }

  const finalPrice =
    discounted(
      originalPrice
    );


  // =========================================================
  // PINTAR PRECIO
  // =========================================================

  mainPrice.innerHTML = `
    <span
      class="kvy-original-price"
      style="
        text-decoration:line-through;
        opacity:.48;
        margin-right:7px;
        font-weight:400;
      "
    >
      ${money(originalPrice)}
    </span>

    <span
      class="kvy-discount-price"
      style="
        font-weight:700;
      "
    >
      ${money(finalPrice)}
    </span>
  `;


  // =========================================================
  // PINTAR €/DÍA
  // =========================================================

  if (
    mainPpd &&
    mainPpd.dataset.kvyOriginalPpd
  ) {

    const originalPpd =
      parseFloat(
        mainPpd.dataset.kvyOriginalPpd
      );

    if (
      Number.isFinite(originalPpd)
    ) {

      mainPpd.textContent =
        '(' +
        money(
          discounted(
            originalPpd
          )
        ) +
        ' / día)';

    }
  }


  return true;
}

  function renderMainPrice() {

    if (
      modifyingMainPrice
    ) {
      return;
    }


    const input =
      getSelectedInput();


    const label =
      getLabel(input);


    if (
      !input ||
      !label
    ) {
      return;
    }


    captureOriginals();


    const key =
      getVariantText(label);


    const data =
      originals.get(key);


    if (!data) {
      return;
    }


    const mainPrice =
      document.querySelector(
        '.c-product__header__price .amount'
      );


    const mainPpd =
      document.querySelector(
        '.c-product__ppd'
      );


    if (!mainPrice) {
      return;
    }


    modifyingMainPrice =
      true;


    if (isTarget(label)) {

      const finalPrice =
        discounted(
          data.price
        );


      mainPrice.innerHTML = `
        <span
          class="kvy-original-price"
          style="
            text-decoration:line-through;
            opacity:.48;
            margin-right:7px;
            font-weight:400;
          "
        >
          ${money(data.price)}
        </span>

        <span
          class="kvy-discount-price"
          style="
            font-weight:700;
          "
        >
          ${money(finalPrice)}
        </span>
      `;


      if (
        mainPpd &&
        data.ppd !== null
      ) {

        mainPpd.textContent =
          '(' +
          money(
            discounted(
              data.ppd
            )
          ) +
          ' / día)';

      }


    } else {

      mainPrice.textContent =
        money(
          data.price
        );


      if (
        mainPpd &&
        data.ppd !== null
      ) {

        mainPpd.textContent =
          '(' +
          money(
            data.ppd
          ) +
          ' / día)';

      }

    }


    requestAnimationFrame(
      function () {

        modifyingMainPrice =
          false;

      }
    );

  }


  // =========================================================
  // 9. RENDER
  // =========================================================

function render() {

  // PRODUCTO SIN VARIANTES
  if (renderSingleProduct()) {
    return;
  }

  // PRODUCTO CON VARIANTES
  renderVariantCards();

  renderMainPrice();
}


  // =========================================================
  // 10. INIT
  // =========================================================

  function init() {

    captureOriginals();

    render();


    // =======================================================
    // CAMBIO DE VARIANTE
    // =======================================================

    document.addEventListener(
      'change',
      function (event) {

        if (
          !event.target.matches(
            '.c-variant__item__input'
          )
        ) {
          return;
        }


        requestAnimationFrame(
          render
        );


        setTimeout(
          render,
          50
        );


        setTimeout(
          render,
          150
        );


        setTimeout(
          render,
          350
        );

      }
    );


    // =======================================================
    // OBSERVAR PRECIO PRINCIPAL
    // =======================================================

    const priceContainer =
      document.querySelector(
        '.c-product__header__price'
      );


    if (priceContainer) {

      const observer =
        new MutationObserver(
          function () {

            if (
              modifyingMainPrice
            ) {
              return;
            }


            requestAnimationFrame(
              function () {

                captureOriginals();

                renderMainPrice();

              }
            );

          }
        );


      observer.observe(
        priceContainer,
        {
          childList: true,
          subtree: true,
          characterData: true
        }
      );

    }


    // =======================================================
    // RERENDER DE VARIANTES
    // =======================================================

    const variantContainer =
      document.querySelector(
        '.c-variant'
      );


    if (variantContainer) {

      let variantTimer =
        null;


      const variantObserver =
        new MutationObserver(
          function () {

            clearTimeout(
              variantTimer
            );


            variantTimer =
              setTimeout(
                function () {

                  captureOriginals();

                  render();

                },
                80
              );

          }
        );


      variantObserver.observe(
        variantContainer,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();